import type { ColumnConfig } from '../../../hooks/useColumnConfig';
import type { OneOnOneHistoryEvent } from '../../../types';

// MED-1346: column ids match the API row fields. A date column groups by its exact time, so it is not groupable.
export const ONE_ON_ONE_HISTORY_COLUMNS: ColumnConfig[] = [
  { id: 'participantName', label: 'Participant', visible: true, sortable: false },
  { id: 'coachName', label: 'Coach', visible: true, sortable: false },
  { id: 'cohortName', label: 'Cohort', visible: true, sortable: false },
  { id: 'oneOnOneType', label: 'Type', visible: true, sortable: false },
  { id: 'sessionNumber', label: '1:1 #', visible: true, sortable: false, numericGroups: true },
  { id: 'firstScheduledStart', label: 'First scheduled', visible: true, sortable: false, groupable: false },
  { id: 'event', label: 'Event', visible: true, sortable: false },
  // R6: the 1:1 as it is now, next to the change.
  { id: 'status', label: 'Status', visible: true, sortable: false },
  { id: 'currentStart', label: 'Current time', visible: true, sortable: false, groupable: false },
  { id: 'fromStart', label: 'From', visible: true, sortable: false, groupable: false },
  { id: 'toStart', label: 'To', visible: true, sortable: false, groupable: false },
  { id: 'createdAt', label: 'Changed at', visible: true, sortable: true, groupable: false },
  { id: 'schedulingMethod', label: 'Booked via', visible: true, sortable: false },
  { id: 'miss', label: 'Miss', visible: true, sortable: false },
];

export const ONE_ON_ONE_HISTORY_EVENT_LABELS: Record<OneOnOneHistoryEvent, string> = {
  booked: 'Booked',
  rescheduled: 'Rescheduled',
  date_cleared: 'Date cleared',
  canceled: 'Canceled',
  no_show: 'No show',
  attended: 'Attended',
  absent: 'Absent',
  attendance_cleared: 'Attendance cleared',
  flagged: 'Late change flagged',
  initial: 'First record',
};

// R6: the event badge tooltip, one plain sentence each.
export const ONE_ON_ONE_HISTORY_EVENT_HELP: Record<OneOnOneHistoryEvent, string> = {
  booked: 'The 1:1 got a date.',
  rescheduled: 'The 1:1 moved from one date to another.',
  date_cleared: 'The date was removed and the 1:1 is undated again.',
  canceled: 'The 1:1 was canceled.',
  no_show: 'The participant did not come, so the 1:1 opened again to book a new date.',
  attended: 'The coach marked the participant as present.',
  absent: 'The coach marked the participant as absent or excused.',
  flagged: 'Staff recorded a no-show or a change made with less than 24 hours notice.',
  attendance_cleared: 'The attendance mark was removed.',
  initial: 'How the 1:1 looked when the history started.',
};

export const ONE_ON_ONE_HISTORY_EVENT_COLORS: Record<OneOnOneHistoryEvent, string> = {
  booked: 'blue',
  rescheduled: 'yellow',
  date_cleared: 'gray',
  canceled: 'dark',
  no_show: 'red',
  attended: 'green',
  absent: 'orange',
  attendance_cleared: 'gray',
  flagged: 'orange',
  initial: 'gray',
};

// The same words as the 1:1 tab "Booked Via" column.
export const SCHEDULING_METHOD_LABELS: Record<string, string> = {
  calendly: 'Calendly',
  calendly_fallback: 'Google invite',
  manual: 'Manual',
};
